import { ApiGatewayManagementApi } from 'aws-sdk';
import moment from 'moment';
import useWebSocket from 'react-use-websocket';
import { getDate } from '../Utils/Time';
import { useUser } from './useUser';
import { useEffect, useMemo } from 'react';
import { WebSocketMessageType } from '../Types/General';
import { useAppDispatch } from '../Redux/store';
import { setVerificationStatus } from '../Redux/slices/WebsocketSlice';
import { AppSettings } from '../Utils/Settings';
import { setHasNotifications } from '../Redux/slices/NotificationSlice';
import { notificationApi } from '../Redux/api/notificationApi';
import { INotification } from '../Types/Notification';
interface useAWSWebsocketProps {}

export const useAWSWebsocket = () => {
    //TODO: Move notification message copy to backend, store in db or in message handler
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { locator } = useUser();
    const {
        sendJsonMessage,
        lastMessage,
        lastJsonMessage,
        readyState
    } = useWebSocket(
        `${AppSettings.WebsocketUrl}?user_locator=${locator}&type=general`, 
        {
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => true,
        },
        ((locator?.length ?? 0 ) > 0)
    );
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const sendMessage = ( body: WebSocketMessage) => {
        sendJsonMessage({
            action: 'message',
            data: {
                ...body,
                sender: body?.sender ?? locator,
                timestamp: body.timestamp ?? getDate()
            }
        });
    }
    const sendNotification = ( body: WebSocketNotification) => {
        sendJsonMessage({
            action: 'notification',
            data: {
                ...body,
                initiator_locator: body?.initiator_locator ?? locator,
                createdAt: getDate()
            }
        });
    }
    /* ******************** Effects ******************** */
    useEffect(() =>{
        if (lastJsonMessage ) {
            console.log('lastJsonMessage: ', lastJsonMessage)
            //@ts-ignore
            const type = lastJsonMessage?.message_type;
            //@ts-ignore
            const message = lastJsonMessage?.message;
            switch(type) {
                case WebSocketMessageType.VerificationUpdate:
                    dispatch(setVerificationStatus(message.status))
                    break;
                case WebSocketMessageType.Notification:
                    dispatch(setHasNotifications(true));
                    dispatch(notificationApi.util.updateQueryData('getNotifications', locator!, (posts) => {
                        posts.push({
                            ...lastJsonMessage as INotification
                        })
                    }))
                    break;
                default:
                    console.log('Unknown websocket message type: ', type)
            }
        }
    }, [lastJsonMessage, lastMessage])
    useEffect(() =>{
        console.log('Websocket Ready state: ', ReadyState[readyState])
    }, [readyState])
    /* ******************** JSX ******************** */
    return {
        sendMessage,
        sendNotification
    }
}
enum ReadyState {
    UNINSTANTIATED = -1,
    CONNECTING = 0,
    OPEN = 1,
    CLOSING = 2,
    CLOSED = 3,
}

interface WebSocketMessage {
    sender?: string;
    receiver: string;
    message: string;
    timestamp?: string;
}
interface WebSocketNotification {
    type: string;
    initiator_locator?: string;
    receiver_locator: string;
    navigation_locator: string;
    notification: string;
}
